import { colorPalette } from '../../colorPalette';
export const deskAvatarSize = '71px';
export const mobAvatarSize = '50px';
const important = '!important';
const deskAvatarValue = `${deskAvatarSize} ${important}`;
const mobAvatarValue = `${mobAvatarSize} ${important}`;
export const mobIconSize = '20px';
export const deskIconSize = '35px';
export const content = {
    width: { xs: mobAvatarValue, sm: deskAvatarValue },
    height: { xs: mobAvatarValue, sm: deskAvatarValue },
    maxWidth: { sm: deskAvatarValue },
    maxHeight: { sm: deskAvatarValue },
    borderRadius: '8px',
};
const square = {
    border: `1px solid ${colorPalette.gray200}`,
};
export const combination = Object.assign(Object.assign({}, content), square);
export const errorCombination = Object.assign(Object.assign(Object.assign({}, content), square), { backgroundColor: `${colorPalette.gray100} !important`, color: `${colorPalette.gray400} !important` });
export const iconClass = (theme) => ({
    fontSize: mobIconSize,
    [theme.breakpoints.up('sm')]: {
        fontSize: deskIconSize,
    },
});
